import { withProperties, getValueAtPath, isPlainObject } from "../../utils";
import { UPDATE_CAMPAIGN } from "../helpers/actions";


export default function state() {
    const NAME = 'campaign';
    const $state = Object.create(null);

    const { data } = this;

    const campaignRelatedItems = {
        new_amount: getValueAtPath(data, 'new_amount'),
        is_discounted: getValueAtPath(data, 'is_discounted'),
        discount: getValueAtPath(data, 'discount'),
        discounted_value: getValueAtPath(data, 'discounted_value'),
        discount_type: getValueAtPath(data, 'discount_type')
    }

    let campaignObject;

    if (getValueAtPath(data, 'campaign')) {
        campaignObject = {
            ...getValueAtPath(data, 'campaign'),
            ...campaignRelatedItems
        };
    }

    const initialCampaign = campaignObject || {};

    function Reducer(state = initialCampaign, action) {
        const payload = isPlainObject(action.payload) ? action.payload : {};
        let campaignCardRelatedItems;

        if (Object.keys(payload).length > 0 && payload.apply_discount) {
            campaignCardRelatedItems = {
                ...payload,
                new_amount: payload.amount_to_pay,
                is_discounted: payload.apply_discount,
                discount: payload.discount_to_apply,
                discounted_value: payload.discounted_value,
                discount_type: payload.discount_type
            }
        }

        switch (action.type) {
            case UPDATE_CAMPAIGN: {
                if (Object.keys(payload).length === 0) {
                    return campaignObject || {};
                }
                return isPlainObject(state) ? {...state, ...campaignCardRelatedItems } : campaignCardRelatedItems;
            }

            default: return state;
        }
        
    }

    function updateCampaign(campaignData) {
        return (dispatch) => {
            dispatch({ type: UPDATE_CAMPAIGN, payload: campaignData });
        }
    }

    withProperties($state, {
        NAME,
        Reducer,
        actions: withProperties(Object.create(null), { updateCampaign })
    });

    return (state = $state);
}